import React from 'react';
import {object, string} from "yup";
import {Box} from "@material-ui/core";
import {FormWrapper, SubmitBtnMerchant} from "../../../../../helpers/FormHandlers";
import {MerchantPageHeader} from "../../../../../helpers/Display";
import {MerchantInput, MerchantTextarea} from "../../../../../helpers/InputsHelpers";
import {apiHelp} from "../../../../../../api/merchant/help";

export default () => {
  const schema = object({
    subject: string().max(200, 'Max length is 200 symbols').trim().required(),
    question: string().max(15000, 'Max length is 15000 symbols').trim().required(),
  });

  return (
    <Box maxWidth="43rem">
      <MerchantPageHeader title="Lunu Support" />
      <FormWrapper
        schema={schema}
        onSubmit={apiHelp}
        resultModalData={['Help', 'Your question has been sent']}
        clearDataOnResult
      >{(formCtx) => (
        <>
          <Box mt="3rem">
            <MerchantInput
              name="subject"
              formCtx={formCtx}
              maxLength={250}
            />
          </Box>
          <Box mt="3rem">
            <MerchantTextarea
              label="Your Question"
              name="question"
              formCtx={formCtx}
              maxLength={15000}
            />
          </Box>
          <Box maxWidth="27rem" mt="3.6rem">
            <SubmitBtnMerchant formCtx={formCtx}>
              Submit
            </SubmitBtnMerchant>
          </Box>
        </>
      )}</FormWrapper>
    </Box>

  )
}
